export default __webpack_public_path__ + "static/media/empty_list.a81af85e.png";